export enum TimeInMilliseconds {
  MilliSecond = 1,
  Second = 1000,
  Minute = 60000,
  Hour = 3600000,
  Day = 86400000,
  Week = 604800000,
}
